import React from 'react';
import {PlayersDashboard as ClassicPlayersDashboard} from './classic';
import {PlayersDashboard as ShowPlayersDashboard} from './showdown';

const PlayersDashboard = {
    get(sportConfig) {
        if (sportConfig.isGameTypeClassic()) {
            return ClassicPlayersDashboard;
        } else if (sportConfig.isGameTypeShowDown()) {
            return ShowPlayersDashboard;
        }

        throw new Error(`get ERR: unknown game type ${sportConfig.getGameType()}`);
    },
};

export {PlayersDashboard};
